export default "__VITE_ASSET__BSukyIZm__"